import getEnv from '../../../services/util/getEnv';
import { firstWeekday, daysInMonth, isWeekend, splitListDateTimes } from './calendarUtil';

const formatCurrency = (currency) => new Intl.NumberFormat('en-US').format(currency);
const reg = () => {
  let n = 123456;
  n = formatCurrency(n).substring(3, 4);
  const reg = new RegExp(`\\${n}`, 'g');
  return reg;
};

const dotReg = reg();

const ACCCopyPasteWhitelist = (getEnv("REACT_APP_ALLOW_COPY_PASTE_IDS") || '')
  .split(',')
  .filter((id) => id)
  .map((id) => parseInt(id));


export {
  dotReg,
  formatCurrency,
  firstWeekday,
  daysInMonth,
  isWeekend,
  splitListDateTimes,
  ACCCopyPasteWhitelist
};
